"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: Object.getOwnPropertyDescriptor(all, name).get
    });
}
_export(exports, {
    get AccessGrantCreatedResponseSchema () {
        return AccessGrantCreatedResponseSchema;
    },
    get AccessGrantListResponseSchema () {
        return AccessGrantListResponseSchema;
    },
    get AccessGrantSchema () {
        return AccessGrantSchema;
    },
    get CreateAccessGrantRequestSchema () {
        return CreateAccessGrantRequestSchema;
    },
    get EMRA_ABILITY_SUBJECTS () {
        return EMRA_ABILITY_SUBJECTS;
    },
    get TENANT_ACCESS_ERROR_CODES () {
        return TENANT_ACCESS_ERROR_CODES;
    },
    get TENANT_ACCESS_HEADER () {
        return TENANT_ACCESS_HEADER;
    },
    get TENANT_ACCESS_REASON_CODES () {
        return TENANT_ACCESS_REASON_CODES;
    },
    get TICKET_REF_PATTERN () {
        return TICKET_REF_PATTERN;
    }
});
const _zod = require("zod");
const TENANT_ACCESS_HEADER = 'x-helix-tenant-access';
const TENANT_ACCESS_REASON_CODES = [
    'onboarding',
    'support',
    'integration',
    'user_admin',
    'incident'
];
const TENANT_ACCESS_ERROR_CODES = {
    /** No live grant for this tenant. The SPA opens the step-up dialog. */ required: 'TENANT_ACCESS_REQUIRED',
    /** The step-up TOTP code was wrong or already used. */ stepUpInvalid: 'STEP_UP_CODE_INVALID',
    /** Too many step-up tries. Wait and try again. */ stepUpLocked: 'STEP_UP_LOCKED',
    /** The access token wasn't minted after MFA. Log in again. */ stepUpMfaRequired: 'STEP_UP_MFA_REQUIRED',
    /** The admin already holds the most live grants allowed. */ tooManyGrants: 'TOO_MANY_ACCESS_GRANTS'
};
const TICKET_REF_PATTERN = /^[A-Z]+-[0-9]+$/;
const CreateAccessGrantRequestSchema = _zod.z.object({
    code: _zod.z.string().regex(/^\d{6}$/, 'code must be 6 digits'),
    reasonCode: _zod.z.enum(TENANT_ACCESS_REASON_CODES),
    ticketRef: _zod.z.string().max(32).regex(TICKET_REF_PATTERN, 'ticketRef must be a Jira key').optional()
}).strict();
const AccessGrantCreatedResponseSchema = _zod.z.object({
    grantId: _zod.z.uuid(),
    token: _zod.z.string().min(1),
    expiresAt: _zod.z.iso.datetime()
}).strict();
const AccessGrantSchema = _zod.z.object({
    grantId: _zod.z.uuid(),
    targetTenantId: _zod.z.uuid(),
    reasonCode: _zod.z.enum(TENANT_ACCESS_REASON_CODES),
    ticketRef: _zod.z.string().nullable(),
    expiresAt: _zod.z.iso.datetime(),
    createdAt: _zod.z.iso.datetime()
}).strict();
const AccessGrantListResponseSchema = _zod.z.object({
    items: _zod.z.array(AccessGrantSchema)
}).strict();
const EMRA_ABILITY_SUBJECTS = [
    'all',
    'User',
    'Role',
    'Permission',
    'MfaSettings',
    'AuditEvent',
    'Patient',
    'Encounter',
    'SoapNote',
    'Prescription',
    'Vitals',
    'Appointment',
    'Tenant',
    'TenantAccessGrant',
    'EmrInstance',
    'OemCustomerLink',
    'IntegrationStatus'
];
